(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-mobile-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  var hero=document.getElementById('ctmHero'), dots=document.getElementById('ctmHeroDots');
  if(hero&&dots){
    hero.addEventListener('scroll',function(){
      var i=Math.round(hero.scrollLeft/hero.clientWidth);
      var ds=dots.children;
      for(var k=0;k<ds.length;k++){ ds[k].className = (k===i)?'on':''; }
    },{passive:true});
  }
})();

  (function(){
    function mkBtn(dir){
      var b=document.createElement('button'); b.className='ctm-arr '+dir; b.type='button';
      b.setAttribute('aria-label', dir==='prev'?'Previous':'Next');
      b.innerHTML = dir==='prev' ? '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>' : '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>';
      return b;
    }
    function arm(track, amt){
      if(!track || track.dataset.armed) return; track.dataset.armed='1';
      var wrap=document.createElement('div'); wrap.className='ctm-hsw';
      track.parentNode.insertBefore(wrap, track); wrap.appendChild(track);
      ['prev','next'].forEach(function(d){
        var btn=mkBtn(d);
        btn.addEventListener('click', function(){ track.scrollBy({left:(d==='prev'?-1:1)*amt(track), behavior:'smooth'}); });
        wrap.appendChild(btn);
      });
    }
    var sels=['.ctm-feat','.ctm-rwall','.ctm-journal','.ctm-int'];
    sels.forEach(function(s){ arm(document.querySelector('.ctm-home '+s), function(t){return t.clientWidth*0.85;}); });
    // hero: 宸叉湁 .ctm-hero-wrap, 鐩存帴鍔犵澶村垏鏁村睆
    var hw=document.querySelector('.ctm-hero-wrap'), ht=document.getElementById('ctmHero');
    if(hw && ht && !hw.dataset.armed){ hw.dataset.armed='1';
      ['prev','next'].forEach(function(d){
        var btn=mkBtn(d);
        btn.addEventListener('click', function(){ ht.scrollBy({left:(d==='prev'?-1:1)*ht.clientWidth, behavior:'smooth'}); });
        hw.appendChild(btn);
      });
    }
  })();

  (function(){
    var proof=document.querySelector('.ctm-home .ct-atlas');
    if(!proof) return;
    var shell=proof.closest('.ctm-atlas-shell');
    var metrics=proof.querySelectorAll('[data-ctm-count]');
    var reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var started=false;
    function start(){
      if(started) return; started=true; proof.classList.add('is-ready'); if(shell) shell.classList.add('ct-proof-ready');
      metrics.forEach(function(el){
        var end=parseInt(el.getAttribute('data-ctm-count'),10)||0;
        if(reduced){el.textContent=end;return;}
        var begin=performance.now(),duration=end>100?1450:980;
        el.textContent='0';
        function tick(now){
          var p=Math.min(1,(now-begin)/duration),eased=1-Math.pow(1-p,3);
          el.textContent=Math.round(end*eased);
          if(p<1) requestAnimationFrame(tick); else el.textContent=end;
        }
        requestAnimationFrame(tick);
      });
    }
    if(reduced||!('IntersectionObserver' in window)){start();}
    else {
      var observer=new IntersectionObserver(function(entries){
        if(entries[0]&&entries[0].isIntersecting){start();observer.disconnect();}
      },{threshold:.18,rootMargin:'0px 0px -6% 0px'});
      observer.observe(proof);
    }

    var routeButtons=Array.prototype.slice.call(proof.querySelectorAll('.ctm-route-cities button'));
    var routeIndex=0, routeImage=proof.querySelector('[data-ctm-route-image]');
    function selectRoute(next){
      if(!routeButtons.length) return;
      routeIndex=(next+routeButtons.length)%routeButtons.length;
      var button=routeButtons[routeIndex];
      routeButtons.forEach(function(item,i){item.classList.toggle('is-active',i===routeIndex);item.setAttribute('aria-pressed',i===routeIndex?'true':'false');});
      proof.querySelector('[data-ctm-route-city]').textContent=button.dataset.city;
      proof.querySelector('[data-ctm-route-kicker]').textContent=button.dataset.city+' · '+button.dataset.days;
      proof.querySelector('[data-ctm-route-title]').textContent=button.dataset.title;
      proof.querySelector('[data-ctm-route-detail]').textContent=button.dataset.detail;
      proof.querySelector('[data-ctm-route-index]').textContent=String(routeIndex+1).padStart(2,'0');
      if(routeImage){routeImage.classList.add('is-switching');routeImage.alt=button.dataset.alt;setTimeout(function(){routeImage.src=button.dataset.image;routeImage.classList.remove('is-switching');},reduced?0:110);}
    }
    routeButtons.forEach(function(button,i){button.addEventListener('click',function(){selectRoute(i);});});
    var routePrev=proof.querySelector('[data-ctm-route-prev]'),routeNext=proof.querySelector('[data-ctm-route-next]');
    if(routePrev) routePrev.addEventListener('click',function(){selectRoute(routeIndex-1);});
    if(routeNext) routeNext.addEventListener('click',function(){selectRoute(routeIndex+1);});
    selectRoute(0);
  })();
// CT_DESTINATION_BROWSER_START
(function () {
  function bindDestinations(scope) {
    scope.querySelectorAll('[data-ct-destination-browser]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var cards = Array.from(root.querySelectorAll('[data-ct-destination]'));
      var input = root.querySelector('[data-ct-destination-search]');
      var region = root.querySelector('[data-ct-destination-region]');
      var previous = root.querySelector('[data-ct-destination-prev]');
      var next = root.querySelector('[data-ct-destination-next]');
      var count = root.querySelector('[data-ct-destination-count]');
      var empty = root.querySelector('[data-ct-destination-empty]');
      var page = 0, size = 4;
      function normalize(value) {
        return value.normalize('NFKD').toLowerCase().replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
      }
      function render() {
        var term = normalize(input.value);
        var matches = cards.filter(function (card) { return (!region.value || card.dataset.region === region.value) && normalize(card.dataset.search).includes(term); });
        page = Math.max(0, Math.min(page, Math.ceil(matches.length / size) - 1));
        var shown = new Set(matches.slice(page * size, (page + 1) * size));
        cards.forEach(function (card) { card.hidden = !shown.has(card); });
        previous.disabled = page === 0;
        next.disabled = (page + 1) * size >= matches.length;
        empty.hidden = matches.length !== 0;
        count.textContent = matches.length ? (page * size + 1) + ' - ' + Math.min((page + 1) * size, matches.length) + ' of ' + matches.length : '0 of 57';
      }
      input.addEventListener('input', function () { page = 0; render(); });
      region.addEventListener('change', function () { page = 0; render(); });
      previous.addEventListener('click', function () { page--; render(); });
      next.addEventListener('click', function () { page++; render(); });
      root.querySelectorAll('[data-ct-destination-controls]').forEach(function (el) { el.hidden = false; });
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bindDestinations(document); });
  else bindDestinations(document);
  document.addEventListener('shopify:section:load', function (event) { bindDestinations(event.target); });
})();
// CT_DESTINATION_BROWSER_END

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

    }



    connectedCallback() {

      this.header = document.getElementById('shopify-section-header');

      this.headerBounds = {};

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch = this.querySelector('predictive-search');



      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;



      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);



      this.createObserver();

    }



    disconnectedCallback() {

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.removeEventListener('scroll', this.onScrollHandler);

    }



    createObserver() {

      let observer = new IntersectionObserver((entries, observer) => {

        this.headerBounds = entries[0].intersectionRect;

        observer.disconnect();

      });



      observer.observe(this.header);

    }



    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;



      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        if (!this.preventReveal) {

          requestAnimationFrame(this.reveal.bind(this));

        } else {

          window.clearTimeout(this.isScrolling);



          this.isScrolling = setTimeout(() => {

            this.preventReveal = false;

          }, 66);



          requestAnimationFrame(this.hide.bind(this));

        }

      } else if (scrollTop <= this.headerBounds.top) {

        requestAnimationFrame(this.reset.bind(this));

      }



      this.currentScrollTop = scrollTop;

    }



    hide() {

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      this.closeMenuDisclosure();

      // this.closeSearchModal();

    }



    reveal() {

      this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.header.classList.remove('shopify-section-header-hidden');

    }



    reset() {

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }



    closeMenuDisclosure() {

      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach(disclosure => disclosure.close());

    }



    // closeSearchModal() {

    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');

    //   this.searchModal.close(false);

    // }

  }



  customElements.define('sticky-header', StickyHeader);

        

        

  class LocalizationForm extends HTMLElement {

    constructor() {

      super();

      this.elements = {

        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),

        button: this.querySelector('button'),

        panel: this.querySelector('.disclosure__list-wrapper'),

      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));

      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));



      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

    }



    hidePanel() {

      this.elements.button.setAttribute('aria-expanded', 'false');

      this.elements.panel.setAttribute('hidden', true);

    }



    onContainerKeyUp(event) {

      if (event.code.toUpperCase() !== 'ESCAPE') return;



      this.hidePanel();

      this.elements.button.focus();

    }



    onItemClick(event) {

      event.preventDefault();

      const form = this.querySelector('form');

      this.elements.input.value = event.currentTarget.dataset.value;

      if (form) form.submit();

    }



    openSelector() {

      this.elements.button.focus();

      this.elements.panel.toggleAttribute('hidden');

      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

    }



    closeSelector(event) {

      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';

      if (event.relatedTarget === null || shouldClose) {

        this.hidePanel();

      }

    }

  }



  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
